import { render, staticRenderFns } from "./l28-tour-result.vue?vue&type=template&id=5a2f8a22&"
import script from "./l28-tour-result.vue?vue&type=script&lang=js&"
export * from "./l28-tour-result.vue?vue&type=script&lang=js&"
import style0 from "./l28-tour-result.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports